(function() {

    'use strict';

    angular.module('app').
    controller('ApiAccessViewController', ApiAccessViewController);

    function ApiAccessViewController($scope, $timeout, toastr, $q, ClientService, $routeParams, $location, ConfirmationModalFactory) {

        var vm = this;

        var viewConfirmation = new ConfirmationModalFactory({},{
            message: 'Your changes haven\'t saved yet. All changes will be lost.',
            code: 'Do you wish to continue?'
        });

        vm.params = $routeParams || {};
        vm.isViewMode = false;
        vm.goTo = goTo;
        vm.back = back;
        vm.apiAccess = {};
        vm.apiAccessId = vm.params.id || false;;
        vm.disableMode = false;
        vm.permissions = [
            {name: 'Read'},
            {name: 'Write'}
        ];
        
        init();

        function init(){

            var promises = [];
            if($routeParams.id){
                $timeout(function (){
                    vm.id = $routeParams.id;
                });
            };
            promises.push(getCompanyList());
            promises.push(getAccounts());

            $q.all(promises).then(function() {
                
            });

        }

        function getCompanyList() {
            ClientService.Company.getAll(function(data) {
                vm.companyList = data.content;
            }, function(err) {
                toastr.error(err.message);
            });
        };

        function getAccounts() {
            ClientService.Account.getAll(function(data) {
                vm.accounts = data.content;
                initAPIAccess();
            }, function(err) {
                toastr.error(err.message);
            });
        };

        function initAPIAccess(){
            ClientService.Client.get(vm.apiAccessId, function(data) {
                vm.apiAccess = data;
                vm.selectCompany(vm.apiAccess.company);
                vm.apiAccessRaw = angular.copy(vm.apiAccess);
                if(vm.apiAccess.company){
                    var newArray = [];
                    angular.forEach(vm.accounts, function(account){
                        if(vm.apiAccess.company.id == account.company.id){
                            newArray.push(account);
                        }
                    });

                    vm.filteredAccounts = newArray;
                }else{
                    vm.filteredAccounts = vm.accounts;
                }

                if(vm.apiAccess.scopes){
                    angular.forEach(vm.permissions, function(permission){
                        if(permission.name.toLowerCase() == vm.apiAccess.scopes){
                            vm.apiAccess.permission = permission;
                        }
                    })
                }
            }, function(err){
                toastr.error(err.message);
            });
        }

        vm.selectCompany = function(company){
            var newArray = [];
            angular.forEach(vm.accounts, function(account){
                if(account.company.id == company.id){
                    newArray.push(account);
                }
            });

            vm.filteredAccounts = newArray;
        };
        
        function goTo(path, params) {
            $location.path(path).search(params);
        };
        
        function back(){
            if(!angular.equals(vm.apiAccess, vm.apiAccessRaw)){
                viewConfirmation.getInstance().result.then(function(cond){
                    if(cond){
                        $location.path('/api-access');
                    }
                });
            }else{
                $location.path('/api-access');
            }
        };

        vm.saveDetails = function(form){

            if(form.$invalid){
                return;
            }
            
            vm.apiAccess = angular.copy(vm.apiAccess);
            
            var accessData = {
                "clientId": vm.apiAccess.clientId,
                "clientSecret" : vm.apiAccess.clientSecret,
                "url": vm.apiAccess.url,
                "companyId": vm.apiAccess.user.company.id,
                "userId": vm.apiAccess.user.id
            };

            if(vm.apiAccess.permission){
                accessData.scopes = vm.apiAccess.permission.name.toLowerCase();
            }

            ClientService.Client.update(
                accessData,
                function(response) {
                    //kcs_console.log(response);
                    toastr.success('Record updated successfully');
                },
                function(error) {
                    //kcs_console.log(error);
                }, accessData.clientId);

        };
    }

})();


// WEBPACK FOOTER //
// ./js/controllers/api-access/ApiAccessViewController.js